module.exports = __webpack_public_path__ + "img/trip_sendai22.1b02d94e.jpg";